<template>
    <v-navigation-drawer
        app
        v-if="$vuetify.breakpoint.xsOnly"
        v-model="updateVisibility"
        class="drawer-section"
        width="310"
        height="100%"
        right
    >
        <v-btn
            v-if="isShowDrawer"
            class="drawer-close-btn"
            icon
            dark
            @click.stop="$emit('update:is-show-drawer', !isShowDrawer)"
        >
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <router-link :to="{ name: 'home' }">
            <div class="drawer-logo">
                <v-img
                    :src="require('@/assets/logo.png')"
                    contain
                    height="27"
                    width="125"
                    max-width="125"
                    :data-ga="`${gaPrefix}logo`"
                ></v-img>
            </div>
        </router-link>
        <div class="drawer-list-group">
            <v-list class="drawer-list-top">
                <v-list-item
                    class="drawer-list-item"
                    v-for="navItem in [...NavItems.left]"
                    :key="navItem.routeName"
                    :to="{ name: navItem.routeName }"
                    :data-ga="`${gaPrefix}${navItem.displayName}`"
                    :ripple="false"
                >
                    <v-list-item-content class="list-content">
                        <v-list-item-title class="list-title">{{
                            navItem.displayName
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-treeview
                    :items="subMenuItems"
                    open-on-click
                    expand-icon="mdi-chevron-down"
                >
                    <template v-slot:prepend="{ item }">
                        <v-list-item
                            v-if="item.type !== 'parent'"
                            class="drawer-list-item"
                            :ripple="false"
                            :to="{ name: item.routeName }"
                            :data-ga="`${gaPrefix}${item.name}`"
                        >
                            <v-list-item-title class="list-title">
                                {{ item.name }}
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-treeview>
                <v-list-item
                    class="drawer-list-item"
                    v-for="navItem in [NavItems.support]"
                    :key="navItem.routeName"
                    :to="{ name: navItem.routeName }"
                    :data-ga="`${gaPrefix}${navItem.displayName}`"
                    :ripple="false"
                >
                    <v-list-item-content class="list-content">
                        <v-list-item-title class="list-title">{{
                            navItem.displayName
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <div class="drawer-divider-wrapper">
                <div class="drawer-divider"></div>
            </div>

            <v-list class="drawer-list-bottom">
                <v-list-item
                    class="drawer-list-item"
                    v-for="navItem in NavItems.right"
                    :key="navItem.routeName"
                    :to="{ name: navItem.routeName }"
                    :data-ga="`${gaPrefix}business`"
                    :ripple="false"
                >
                    <v-list-item-content>
                        <v-list-item-title class="list-title"
                            >Business inquiries</v-list-item-title
                        >
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </div>
    </v-navigation-drawer>
</template>

<script>
import NavItems from '@/NavItems';
import { MANAGE_CARDS } from '@/constatns';

export default {
    name: 'navbar-drawer',
    props: {
        isShowDrawer: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        gaPrefix: 'Top Navigation|',
    }),
    computed: {
        NavItems() {
            return NavItems;
        },
        updateVisibility: {
            get() {
                return this.isShowDrawer;
            },
            set(value) {
                this.$emit('update:is-show-drawer', value);
            },
        },
        subMenuItems() {
            return [
                {
                    id: 1,
                    name: MANAGE_CARDS,
                    type: 'parent',
                    children: [
                        ...NavItems.manage.map((e, i) => ({
                            id: i + 2,
                            name: e.displayName,
                            routeName: e.routeName,
                        })),
                    ],
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.drawer-section {
    text-align: center;
    overflow: visible;
    .drawer-close-btn {
        position: absolute;
        top: 8px;
        left: -48px;
        .v-icon {
            font-size: 34px;
        }
    }
    .drawer-close-btn.v-btn {
        &:before {
            background-color: transparent;
        }
        &:hover {
            background-color: transparent;
        }
    }
    .drawer-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
    }
    .drawer-list-group {
        background-color: #f6f6f6;
        width: 100%;
        height: calc(100vh - 60px);
        .drawer-list-top {
            padding-top: 20px;
            .drawer-list-item {
                padding: 10px;
                .list-title {
                    font-weight: 500;
                    font-size: 14px;
                    text-transform: uppercase;
                    letter-spacing: normal;
                }
            }
            .v-list-item {
                &:before {
                    background: transparent;
                }
                &:hover {
                    color: #2960e8 !important;
                }
            }
            .v-list-item--active {
                color: #2960e8 !important;
            }
        }
        .drawer-list-bottom {
            .list-title {
                font-size: 14px;
                font-weight: 500;
                text-transform: uppercase;
                letter-spacing: normal;
            }
            .v-list-item--link {
                &:before {
                    background: transparent;
                }
            }
        }

        .drawer-divider-wrapper {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 10px;
            .drawer-divider {
                width: 16px;
                height: 1px;
                border-radius: 1.5px;
                background-color: #7b7b7b;
            }
        }
    }
}
</style>
<style lang="scss">
.drawer-section {
    .v-treeview-node__root {
        flex-direction: row-reverse;
        justify-content: center;
        .v-treeview-node__label {
            font-weight: 500;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: normal;
            margin-left: 29px;
        }

        .v-treeview-node__content {
            flex-grow: 0;
            flex-basis: auto;
            flex-shrink: 1;
        }
    }
    .v-treeview-node__children {
        .list-title {
            font-size: 13px !important;
            color: #888888;

            &:hover {
                color: #2960e8 !important;
            }
        }

        .v-list-item--active {
            .list-title {
                color: #2960e8;
            }
        }
        .v-treeview-node--leaf {
            margin-left: 20px;
        }
    }
    .theme--light.v-treeview--hoverable .v-treeview-node__root:hover::before,
    .theme--light.v-treeview
        .v-treeview-node--click
        > .v-treeview-node__root:hover::before {
        opacity: 0;
    }
}
</style>
